import Immutable from 'immutable';
import { defaultCommunicationObject, updateCommunicationObject } from '~reducers/shared';
import { tagsListActionTypes } from '~constants/actionTypes';

export const defaultState = Immutable.fromJS({
  list: {
    payload: [],
    total: 0,
  },
  communication: {
    list: defaultCommunicationObject,
  },
});

const formatPayload = tags =>
  tags.map(tag => ({
    id: tag?.node?.id,
    name: tag?.node?.name,
    tags: tag?.node?.tags,
    applyLevel: tag?.node?.applyLevel,
    displaySettings: tag?.node?.displaySettings,
    endDate: tag?.node?.endDate,
    startDate: tag?.node?.startDate,
    ranking: tag?.node?.ranking,
    updatedUser: tag?.node?.updatedUser,
    updatedAt: tag?.node?.updatedAt,
    status: tag?.node?.status,
  }));

const tagsReducer = (state = defaultState, action) => {
  switch (action.type) {
    case tagsListActionTypes.SET_LIST: {
      const nextState = state.deleteIn(['list', 'payload']);
      return nextState.mergeDeep({
        list: {
          payload: formatPayload(action.payload.edges),
          total: action.payload.totalCount,
        },
      });
    }

    case tagsListActionTypes.LIST_CS:
      return state.mergeDeep({
        communication: {
          list: updateCommunicationObject(action.status, action.error),
        },
      });

    default:
      return state;
  }
};

export default tagsReducer;
